import $ from 'jquery'
import 'jquery-ui/ui/widgets/datepicker';
import 'jquery-validation';


function WL_Order() {
    $('.wl-order').each(function () {
        let $form = $(this);


        function updateProductInfo() {
            let $image = $form.find('.js-selected-image');
            let $title = $form.find('.js-selected-title');
            let $wasteType = $form.find('.js-selected-type');

            let $selectedSkip = $form.find('.wl-order__sizes-item__radio:checked');
            let $selectedType = $form.find('.wl-order__types-item__radio:checked');

            let imageSrc = $selectedSkip.data('image');
            let skipName = $selectedSkip.data('name');
            let wasteType = $selectedType.data('name');

            $image.attr('src', imageSrc);
            $title.text(skipName);
            $wasteType.text(wasteType);
        }
        updateProductInfo();

        function updateProductPrice(response) {

            let $wastePrice = $form.find('.js-selected-price');
            let $postcodeError = $form.find('.wl-order__postcode-error');
            let $optionsError = $form.find('.wl-order__options-errors');

            if (response.success) {
                $postcodeError.hide();
                $optionsError.hide();
                $wastePrice.html(response.data.product_price_vat + '<span class="vat">including VAT</span>');
                $form.find('#product-id').val(response.data.product_id);
            } else {
                if (response.data.error_type == "no_zone") {
                    $postcodeError.show();
                    $postcodeError.html(response.data.message);
                    $optionsError.show();
                    $optionsError.html(response.data.message);
                } else if (response.data.error_type == "no_skips") {
                    $postcodeError.hide();
                    $wastePrice.html(response.data.message);
                    $optionsError.show();
                    $optionsError.html(response.data.message);
                }
            }

        }

        function updateProductPriceAndAttributes(response) {

            let $wastePrice = $form.find('.js-selected-price');
            let $postcodeError = $form.find('.wl-order__postcode-error');
            let $optionsError = $form.find('.wl-order__options-errors');

            if (response.success) {
                $postcodeError.hide();
                $optionsError.hide();
                $wastePrice.html(response.data.product_data.product_price_vat + '<span class="vat">including VAT</span>');
                $form.find('#product-id').val(response.data.product_data.product_id);
                
                $form.find('.wl-order__sizes-item__radio').parent().hide();
                response.data.skip_sizes.forEach((element , index) => {
                    $form.find('.wl-order__sizes-item__radio[value="'+element.slug+'"]').parent().show();
                    if(index == 0){
                        $form.find('.wl-order__sizes-item__radio[value="'+element.slug+'"]').prop("checked", true);
                    }
                });

                $form.find('.wl-order__types-item__radio').parent().hide();
                response.data.waste_types.forEach((element , index) => {
                    $form.find('.wl-order__types-item__radio[value="'+element.slug+'"]').parent().show();
                    if(index == 0){
                        $form.find('.wl-order__types-item__radio[value="'+element.slug+'"]').prop("checked", true);
                    }
                });

            } else {
                if (response.data.error_type == "no_zone") {
                    $postcodeError.show();
                    $postcodeError.html(response.data.message);
                    $optionsError.show();
                    $optionsError.html(response.data.message);
                } else if (response.data.error_type == "no_skips") {
                    $postcodeError.hide();
                    $wastePrice.html(response.data.message);
                    $optionsError.show();
                    $optionsError.html(response.data.message);
                }
            }

        }

        $(this).find('.wl-order__postcode-btn').on('click', function (e) {
            e.preventDefault();

            var postcode = $form.find('#postcode').val();
            let $postcodeError = $form.find('.wl-order__postcode-error');
            if (postcode) {
                $form.find('#postcode-form').val(postcode.toUpperCase());
                $form.find('#product-id').val('');
                $.ajax({
                    url: ajaxObject.ajax_url,
                    type: 'POST',
                    data: {
                        action: 'get_matching_product_and_attributes',
                        postcode: postcode,
                    },
                    success: function (response) {
                        updateProductPriceAndAttributes(response);
                        updateProductInfo();

                        if (response.data.error_type != "no_zone") {
                            $('html, body').animate({ scrollTop: $form.find('.wl-order__options').offset().top - 120 }, 300);
                        }
                    }
                });
            } else{
                $postcodeError.show();
                $postcodeError.html('Plese enter the postcode.');
            }


        });
        $(this).find('.wl-order__sizes-item__radio, .wl-order__types-item__radio').on('change', function () {
            var postcode = $form.find('#postcode').val();
            var skipSize = $form.find('.wl-order__sizes-item__radio:checked').val();
            var wasteType = $form.find('.wl-order__types-item__radio:checked').val();
            let $postcodeError = $form.find('.wl-order__postcode-error');
            updateProductInfo();
            if (postcode) {
                $form.find('#postcode-form').val(postcode.toUpperCase());
                $form.find('#product-id').val('');
                $.ajax({
                    url: ajaxObject.ajax_url,
                    type: 'POST',
                    data: {
                        action: 'get_matching_product',
                        postcode: postcode,
                        skip_size: skipSize,
                        waste_type: wasteType
                    },
                    success: function (response) {
                        console.log(response);
                        updateProductInfo();
                        updateProductPrice(response);
                    }
                });
            } else{
                $('html, body').animate({ scrollTop: $form.find('.wl-order__top').offset().top - 120 }, 300);
                $postcodeError.show();
                $postcodeError.html('Plese enter the postcode.');
            }
        });

        // Get delivery and collection date elements
        let $delivery_date = $(this).find('#delivery_date');
        let $collection_date = $(this).find('#collection_date');

        // List of specific holidays (ignoring the year)
        let holidays = [
            { month: 3, day: 15 },  // Good Friday - 15 April
            { month: 3, day: 18 },  // Easter Monday - 18 April
            { month: 4, day: 2 },   // Early May Bank Holiday - 2 May
            { month: 5, day: 2 },   // Spring Bank Holiday - 2 June
            { month: 5, day: 3 },   // Platinum Jubilee bank holiday - 3 June
            { month: 7, day: 29 },  // Summer Bank Holiday - 29 August
        ];

        // Convert disableDates to a Set for efficient lookup
        let disabledExactDates = new Set(
            disableDates.map(item => item.date) // e.g., "28/04/2025"
        );

        // Christmas holiday range
        let christmasBreakStart = new Date(new Date().getFullYear(), 11, 21);  // December 21
        let christmasBreakEnd = new Date(new Date().getFullYear() + 1, 0, 5);  // January 5

        // Function to check if a date is a holiday (ignores year)
        function isHoliday(date) {
            return holidays.some(function (holiday) {
                return date.getMonth() === holiday.month && date.getDate() === holiday.day;
            });
        }

        // Function to add working days
        function addWorkingDays(date, days) {
            let result = new Date(date);
            while (days > 0) {
                result.setDate(result.getDate() + 1);
                if (result.getDay() !== 0 && result.getDay() !== 6 && !isHoliday(result) &&
                    !(result >= christmasBreakStart && result <= christmasBreakEnd)) {
                    days--;
                }
            }
            return result;
        }

        // Function to get the next valid date after a given date
        function getNextValidDate(date) {
            let nextDate = new Date(date);
            do {
                nextDate.setDate(nextDate.getDate() + 1);
            } while (nextDate.getDay() === 0 || nextDate.getDay() === 6 || isHoliday(nextDate) ||
                (nextDate >= christmasBreakStart && nextDate <= christmasBreakEnd));
            return nextDate;
        }

        // Initialize Delivery Datepicker
        $delivery_date.datepicker({
            beforeShowDay: function (date) {
                let day = date.getDay();
                let formatted = $.datepicker.formatDate('dd/mm/yy', date);
                let isHolidayDate = isHoliday(date);
                
                // Disable weekends, holidays, Christmas break, and JSON-defined disabled dates
                if (
                    day === 0 || day === 6 || 
                    isHolidayDate || 
                    (date >= christmasBreakStart && date <= christmasBreakEnd) ||
                    disabledExactDates.has(formatted)
                ) {
                    return [false, "", "Unavailable"];
                }
            
                return [true];
            },
            minDate: addWorkingDays(new Date(), 2), // First available booking date is 2 working days from today
            dateFormat: 'dd/mm/yy',
            numberOfMonths: 1,
            inline: true,
            firstDay: 1,
            onSelect: function (selectedDate) {
                let deliveryDate = $(this).datepicker('getDate');
                let collectionMinDate = getNextValidDate(deliveryDate); // Get the next valid collection date
                let collectionMaxDate = addWorkingDays(deliveryDate, 14); // Max rental period is 14 working days

                $collection_date.datepicker('option', {
                    minDate: collectionMinDate,
                    maxDate: collectionMaxDate
                });
            }
        });

        // Initialize Collection Datepicker
        $collection_date.datepicker({
            beforeShowDay: function (date) {
                let day = date.getDay();
                let formatted = $.datepicker.formatDate('dd/mm/yy', date);
                let isHolidayDate = isHoliday(date);
                
                // Disable weekends, holidays, Christmas break, and JSON-defined disabled dates
                if (
                    day === 0 || day === 6 || 
                    isHolidayDate || 
                    (date >= christmasBreakStart && date <= christmasBreakEnd) ||
                    disabledExactDates.has(formatted)
                ) {
                    return [false, "", "Unavailable"];
                }
            
                return [true];
            },
            minDate: addWorkingDays(new Date(), 3), // Will be updated based on delivery date selection
            maxDate: new Date(addWorkingDays(new Date(), 3).getTime() + (14 * 24 * 60 * 60 * 1000)),
            dateFormat: 'dd/mm/yy',
            numberOfMonths: 1,
            inline: true,
            firstDay: 1
        });




        let $formElement = $form.find('#wl-checkout-form');

        //permit note
        let formBtn = $formElement.find('.button');
        let formSkipLocation = $formElement.find('#skip-location');
        let formSkipPermit = $formElement.find('.wl-order__bottom-form-permit');
        formSkipLocation.on('change', function () {
            let val = $(this).val();
            if (val == 'private') {
                formBtn.show();
                formSkipPermit.hide();
            } else {
                formBtn.hide();
                formSkipPermit.show();
            }
        });

        $form.find('#wl-checkout-form').submit(function (e) {
            e.preventDefault();
        }).validate({
            rules: {
                "first-name": {
                    required: true,
                    minlength: 2
                },
                "last-name": {
                    required: true,
                    minlength: 2
                },
                "email": {
                    required: true,
                    email: true
                },
                "phone": {
                    required: true,
                },
                "postcode-form": {
                    required: true,
                    minlength: 3
                },
                "address": {
                    required: true
                },
                "city": {
                    required: true
                },
                "terms": {
                    required: true
                }
            },
            messages: {
                "first-name": {
                    required: "First name is required",
                    minlength: "First name must be at least 2 characters long"
                },
                "last-name": {
                    required: "Last name is required",
                    minlength: "Last name must be at least 2 characters long"
                },
                "email": {
                    required: "Email is required",
                    email: "Please enter a valid email address"
                },
                "phone": {
                    required: "Phone number is required",
                },
                "postcode-form": {
                    required: "Enter your postcode at the top of the page.",
                    minlength: "Postcode must be at least 3 characters long"
                },
                "address": {
                    required: "Address is required"
                },
                "city": {
                    required: "City/Town is required"
                },
                "terms": {
                    required: "This field is required"
                },
            },
            submitHandler: function (form) {
                // Custom submit logic (AJAX request, etc.)
                // e.g., trigger your custom form submit logic here
                // Get product and form details
                var product_id = $formElement.find('#product-id').val();  // Assuming this holds the product ID
                var delivery_date = $form.find('#delivery_date').datepicker('getDate'); // Get delivery date
                var collection_date = $form.find('#collection_date').datepicker('getDate'); // Get collection ready date
                var delivery_time = $form.find('#delivery_time').val();
                var collection_time = $form.find('#collection_time').val();
                var first_name = $formElement.find('#first-name').val();
                var last_name = $formElement.find('#last-name').val();
                var email = $formElement.find('#email').val();
                var phone = $formElement.find('#phone').val();
                var postcode = $formElement.find('#postcode-form').val();
                var address = $formElement.find('#address').val();
                var city = $formElement.find('#city').val();


                var formatted_delivery_date = $.datepicker.formatDate('dd/mm/yy', delivery_date);
                var formatted_collection_date = $.datepicker.formatDate('dd/mm/yy', collection_date);

                var data = {
                    action: 'add_product_to_cart',
                    product_id: product_id,
                    delivery_date: formatted_delivery_date,
                    delivery_time: delivery_time,
                    collection_date: formatted_collection_date,
                    collection_time: collection_time,
                    first_name: first_name,
                    last_name: last_name,
                    email: email,
                    phone: phone,
                    postcode: postcode,
                    address: address,
                    city: city
                };

                //console.log(data)
                // Send AJAX request to add the product to the cart
                $.ajax({
                    url: ajaxObject.ajax_url,
                    type: 'POST',
                    data: data,
                    success: function (response) {
                        if (response.success) {
                            // Redirect to the checkout page
                            //console.log(response);
                            window.location.href = response.data.checkout_url;
                        } else {
                            // Handle error
                            alert(response.data.message);
                        }
                    },
                    error: function () {
                        alert('An error occurred. Please try again.');
                    }
                });
            }
        });


    });
}

export { WL_Order }
